// Shared focus-trap helper for off-canvas panels and modals (cart aside,
// mobile menu, site modal). Keeps Tab/Shift+Tab cycling within the open
// panel and restores focus to the trigger element on close.
(function () {
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let activeTrap = null;

  function getFocusable(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
      (el) => el.offsetParent !== null
    );
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Tab" || !activeTrap) return;

    const focusable = getFocusable(activeTrap.container);
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.trapFocus = function (container, initialFocusEl) {
    activeTrap = { container, trigger: document.activeElement };
    const toFocus = initialFocusEl || getFocusable(container)[0];
    if (toFocus) toFocus.focus();
  };

  window.releaseFocusTrap = function () {
    if (activeTrap && activeTrap.trigger && typeof activeTrap.trigger.focus === "function") {
      activeTrap.trigger.focus();
    }
    activeTrap = null;
  };
})();
